import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useCallback } from 'react';

interface IServiceTimeSelectorProps {
  value: number;
  onChange: (n: number) => void;
  disabled?: boolean;
}

const ServiceTimeSelector = (props: IServiceTimeSelectorProps) => {
  const onChange = useCallback(
    ({ target: { value } }: any) => props.onChange(parseInt(value)),
    [props.onChange],
  );
  return (
    <FormControl fullWidth size="small">
      <InputLabel id="service-time-label">Tiempo por parada</InputLabel>
      <Select
        labelId="service-time-label"
        label="Tiempo por parada"
        onChange={onChange}
        value={props.value}
      >
        <MenuItem value={1 * 60}>1 min</MenuItem>
        <MenuItem value={2 * 60}>2 min</MenuItem>
        <MenuItem value={3 * 60}>3 min</MenuItem>
        <MenuItem value={4 * 60}>4 min</MenuItem>
        <MenuItem value={5 * 60}>5 min</MenuItem>
        <MenuItem value={6 * 60}>6 min</MenuItem>
        <MenuItem value={7 * 60}>7 min</MenuItem>
        <MenuItem value={8 * 60}>8 min</MenuItem>
        <MenuItem value={9 * 60}>9 min</MenuItem>
        <MenuItem value={10 * 60}>10 min</MenuItem>
        <MenuItem value={11 * 60}>11 min</MenuItem>
        <MenuItem value={12 * 60}>12 min</MenuItem>
        <MenuItem value={13 * 60}>13 min</MenuItem>
        <MenuItem value={14 * 60}>14 min</MenuItem>
        <MenuItem value={15 * 60}>15 min</MenuItem>
        <MenuItem value={16 * 60}>16 min</MenuItem>
        <MenuItem value={17 * 60}>17 min</MenuItem>
        <MenuItem value={18 * 60}>18 min</MenuItem>
        <MenuItem value={19 * 60}>19 min</MenuItem>
        <MenuItem value={20 * 60}>20 min</MenuItem>
      </Select>
    </FormControl>
  );
};

export default ServiceTimeSelector;
